"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportList = void 0;
var React = require("react");
var ReactRedux = require("react-redux");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var SokReducerTypes = require("@caddigital/sok-reducers/lib/types");
var sok_ui_1 = require("@caddigital/sok-ui");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var Utils = require("./utils");
var ListHeader_1 = require("./components/ListHeader");
var ListRow_1 = require("./components/ListRow");
require("./index.scss");
var component = function (props) {
    var _a, _b;
    var dispatchers = Utils.mapDispatchers(ReactRedux.useDispatch());
    var reportFile = ReactRedux.useSelector(function (state) { return state.reports.reportFile; });
    var reportList = ReactRedux.useSelector(function (state) { return state.reports.reportList; });
    var _c = React.useState(0), contentWidth = _c[0], setContentWidth = _c[1];
    var _d = React.useState(Utils.listColumns(props.listEntryType)), columns = _d[0], setColumns = _d[1];
    var _e = React.useState([]), items = _e[0], setItems = _e[1];
    var _f = React.useState(Utils.defaultFilteringOptions()), filteringOptions = _f[0], setFilteringOptions = _f[1];
    var style = React.useState({})[0];
    React.useEffect(function () { return function () { return void dispatchers.clearReportFile(); }; }, []);
    React.useEffect(function () {
        return void dispatchers.fetchReportList(props.customer.id, props.listEntryType);
    }, [props.listEntryType]);
    React.useEffect(function () {
        var filteredSortedData = Utils.filterSortData(reportList.reports, filteringOptions);
        var _a = Utils.mapData(filteredSortedData, props.listEntryType), items = _a.items, columns = _a.columns;
        setColumns(columns);
        setItems(items);
    }, [reportList, filteringOptions]);
    React.useEffect(function () { return void setContentWidth(Utils.calculateContentPixelWidth(columns)); }, [items]);
    React.useEffect(function () {
        var clearReportFile = dispatchers.clearReportFile, showReportFileErrorToast = dispatchers.showReportFileErrorToast;
        var fileName = reportFile.fileName, status = reportFile.status;
        if (status === SokReducerTypes.FAILED) {
            showReportFileErrorToast(fileName !== null && fileName !== void 0 ? fileName : '');
            clearReportFile();
            return;
        }
        Utils.downloadReportFile(reportFile, clearReportFile);
    }, [reportFile]);
    var listData = {
        columns: columns,
        items: items,
        selectedUuids: (_b = (_a = props.selectedItems) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.uuid; })) !== null && _b !== void 0 ? _b : [],
        filteringOptions: filteringOptions,
        listEntryType: props.listEntryType,
        isReportFileFetching: reportFile.status === SokReducerTypes.FETCHING,
        filterBy: function (prop, value) {
            var filters = filteringOptions.filters;
            var newFilters = value
                ? __spreadArray(__spreadArray([], filters, true), [{ prop: prop, value: value.toLowerCase() }], false) : filters.filter(function (filter) { return filter.prop !== prop; });
            setFilteringOptions(__assign(__assign({}, filteringOptions), { filters: newFilters }));
        },
        sortBy: function (prop, order) {
            return setFilteringOptions(__assign(__assign({}, filteringOptions), { sort: { prop: prop, order: order !== null && order !== void 0 ? order : 'asc' } }));
        },
        onDownloadButtonClick: dispatchers.fetchReportFile,
        onInfoButtonClick: props.onInfoButtonClick,
        onSelectionChange: function (uuids) {
            var _a;
            return (_a = props.onSelectionChange) === null || _a === void 0 ? void 0 : _a.call(props, items.filter(function (item) { return uuids.includes(item.uuid); }));
        }
    };
    var header = React.createElement(ListHeader_1.ListHeader, { data: listData, style: style });
    var placeholder = (React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { title: 'management/reports/list/empty/title', message: 'management/reports/list/empty/message' }));
    return (React.createElement("div", { className: 'report-list-container' },
        React.createElement("div", { className: 'sok-list-content report-list' },
            reportList.status === SokReducerTypes.FAILED && (React.createElement(GenericErrorMessage_1.default, { key: 'error' },
                React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                        return dispatchers.fetchReportList(props.customer.id, props.listEntryType);
                    } }))),
            reportList.status === SokReducerTypes.FETCHING && (React.createElement("div", { className: 'loading-spinner-container' },
                React.createElement(sok_ui_1.LoadingSpinner, null))),
            reportList.status === SokReducerTypes.FETCHED && (React.createElement(React.Fragment, null,
                React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { header: header, placeholder: placeholder, itemCount: listData.items.length, itemData: listData, itemWidth: contentWidth, itemHeight: Utils.ROW_PIXEL_HEIGHT, width: width, height: height }, ListRow_1.ListRow));
                }))))));
};
exports.ReportList = component;
